import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function UnauthorizedPage() {
  const { signOut, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
    } catch (err) {
      console.error(err);
    }
    navigate('/');
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-background" data-testid="unauthorized-page">
      <Card className="w-full max-w-md shadow-[var(--shadow-2)]">
        <CardHeader className="text-left pb-2">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-destructive/10 flex items-center justify-center">
              <ShieldAlert className="h-5 w-5 text-destructive" />
            </div>
            <CardTitle className="text-xl" data-role="heading">Access Restricted</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Access restricted to <span className="font-medium text-foreground">Cam Marketing Group</span> personnel only.
            Only accounts ending in <span className="font-medium text-foreground">@cammarketinggroup.com</span> are permitted.
          </p>
          {user && (
            <p className="text-xs text-muted-foreground">
              Signed in as: <span className="font-medium">{user.email}</span>
            </p>
          )}
          <Button
            onClick={handleLogout}
            variant="outline"
            className="w-full transition-colors duration-150 active:scale-[0.98]"
            data-testid="unauthorized-logout-button"
          >
            Return to Login
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
